import { DESKTOP_HEADER_TRACKING_EVENTS } from '../constants';

/**
 * Keeps payloads identical across dispatchers with different eventLabel defaults.
 * Extra taxonomy fields must be added only when the analytics contract requires them.
 */

// Kept local to avoid a components dependency.
export type DesktopHeaderTrackingLevel = keyof typeof DESKTOP_HEADER_TRACKING_EVENTS;

export type DesktopHeaderTrackingInput = {
  level: DesktopHeaderTrackingLevel;
  selection: string;
};

export type DesktopHeaderTrackingEvent = {
  event: string;
  eventLabel: string;
  selection: string;
};

export const buildDesktopHeaderTrackingEvent = ({
  level,
  selection,
}: DesktopHeaderTrackingInput): DesktopHeaderTrackingEvent => ({
  event: DESKTOP_HEADER_TRACKING_EVENTS[level],
  eventLabel: '',
  selection,
});
